import { useEffect } from "react";

import type { RegisterDraft } from "../types";
import { useRegisterStepper } from "./RegisterStepper";

/**
 * Redirects to the first step if registration draft is missing (e.g. direct navigation, cleared state).
 */
export function useRegisterDraftGuard(draft: RegisterDraft | undefined, firstStepKey: string) {
    const { goTo } = useRegisterStepper();

    useEffect(() => {
        if (draft == null) {
            goTo(firstStepKey);
        }
    }, [draft, firstStepKey, goTo]);
}
